<template>
  <v-row no-gutters :style="{ 'min-height': '100vh' }">
    <v-col cols="12" md="8" offset-md="2" lg="8" offset-lg="2" xl="4" offset-xl="4" class="pa-4">
      <v-row>
        <v-col cols="12">
          <div class="mt-10">
            <div class="text-center" style="height: 150px;">
              <lottie-player
                v-pre
                src="https://assets2.lottiefiles.com/packages/lf20_tvhv0ibf.json"
                background="transparent"
                speed="3"
                loop
                autoplay
                style="width: 300px; height: 150px; display: inline;"
              ></lottie-player>
            </div>

            <h1 class="text-center mt-5 mb-10 text-h2">
              Export
            </h1>

            <p class="text-center">
              You can export your bookmarks in HTML or JSON format.
            </p>
          </div>
        </v-col>
      </v-row>
      <v-row >
        <v-col cols="12" md="6"  class="pb-5">
          <v-card class="text-center px-10 py-8" color="grey lighten-4" flat>
            <v-btn color="primary" large @click="downloadHTML">
              <v-icon left>mdi-download</v-icon> download html file
            </v-btn>
          </v-card>
          <p class="text-justify mt-5">
            Global file type for bookmarks. Does not include Bookmark Expert specific features such as <em>notes</em>, favorites or whether folders
            are <em>hidden</em> or not. Use it to:
              <ul class="mt-5">
                <li>Import them to another application such as Chrome, Safari, Firefox and Opera</li>
              </ul>
          </p>
        </v-col>
        <v-col cols="12" md="6" class="pb-5">
          <v-card class="text-center px-10 py-8" color="grey lighten-4" flat>
            <v-btn color="primary" large @click="downloadJSON">
              <v-icon left>mdi-download</v-icon> download json file
            </v-btn>
          </v-card>
          <p class="text-justify mt-5">
            File type that holds all features of bookmarks such as notes, favorites and whether folders
            are <em>hidden</em> or not. Use it to:
            <ul class="mt-5">
              <li>Take snapshot for your Bookmark Expert data</li>
              <li>Share with other Bookmark Expert users</li>
            </ul>
          </p>
        </v-col>
      </v-row>
    </v-col>
  </v-row>
</template>

<script>
import fn from "../helpers/functions";
export default {
  name: "Export",
  metaInfo() {
    return this.generateMeta({ name: "export", path: this.$route.path });
  },
  mounted() {
    setTimeout(() => {
      // console.log(this.$store.state.bookmarks);
      // debugger;
      // prettier-ignore
      console.log(fn.nestedObjGenerator(Object.values(this.$store.state.bookmarks), 0),"nestedObjGenerator");
    }, 1000);
  },
  methods: {
    downloadJSON(){
      let items = Object.values(this.$store.state.bookmarks)
      // remove HOME folder
      items = items.filter(v=>v.id != 0)
      // remove "selected" attribute
      items.forEach(v=>delete v.selected)

      var json = JSON.stringify(items, null, 2)
      console.log(json)

      var blob = new Blob([json], { type: "application/json" });
      var url = URL.createObjectURL(blob);
      var a = document.createElement("a");
      a.download = `Bookmark_Expert_Export_${this.formatDate(new Date())}.json`; // prettier-ignore
      a.href = url;
      a.textContent = "Download backup file";
      a.style.display = "none";
      document.body.appendChild(a);
      a.click();
    },
    downloadHTML() {
      const obj = fn.nestedObjGenerator(Object.values(this.$store.state.bookmarks), 0);

      let html = `<!DOCTYPE NETSCAPE-Bookmark-file-1>
<!-- This is an automatically generated file.
     It will be read and overwritten.
     DO NOT EDIT! -->
<META HTTP-EQUIV="Content-Type" CONTENT="text/html; charset=UTF-8">
<TITLE>Bookmarks</TITLE>
<H1>Bookmark Expert</H1>
`;

      function addItemHTML(item) {
        if (item.type == "url") {
          html += `<DT><A HREF="${item.url}" ADD_DATE="${item.createdAt}" LAST_MODIFIED="${item.updatedAt || item.createdAt}">${item.label}</A>\n`; //prettier-ignore
        } else {
          html += `<DT><H3 ADD_DATE="${item.createdAt}" LAST_MODIFIED="${item.updatedAt || item.createdAt}">${item.label}</H3>\n`; //prettier-ignore
          html += `<DL><p>\n`;
          item.children.forEach((g) => {
            addItemHTML(g);
          });
          html += `</DL><p>\n`;
        }
      }

      html += "<DL><p>\n";
      obj.forEach((g) => {
        addItemHTML(g);
      });
      html += "</DL><p>";

      console.log(html);

      var blob = new Blob([html], { type: "application/json" });
      var url = URL.createObjectURL(blob);
      var a = document.createElement("a");
      a.download = `Bookmark_Expert_Export_${this.formatDate(new Date())}.html`; // prettier-ignore
      a.href = url;
      a.textContent = "Download backup file";
      a.style.display = "none";
      document.body.appendChild(a);
      a.click();
    },
    formatDate(date) {
      return (
        this.addZero(date.getFullYear()) +
        "_" +
        this.addZero(date.getMonth() + 1) +
        "_" +
        this.addZero(date.getDate()) +
        "_" +
        this.addZero(date.getHours()) +
        "_" +
        this.addZero(date.getMinutes()) +
        "_" +
        this.addZero(date.getSeconds())
      );
    },
    addZero(number) {
      if (number < 10) number = "0" + number.toString();
      return number.toString();
    },
  },
};
</script>
